(function(angular){
	'use strict';

	angular
		.module('incomeReitHistoricalDividendsChartModule')
		.directive('incomeReitHistoricalDividendsChart', [
			'$filter',
			'Highcharts', 
			'HIGHCHARTS_OPTIONS', 
			losAngelesHomePriceChartFunction
		]);

	function losAngelesHomePriceChartFunction(
		$filter,
		Highcharts, 
		HIGHCHARTS_OPTIONS
	) {
		return {
			template: '<div id="income-ereit-historical-dividends-chart" class="coterminous"></div>',
			restrict: 'E',
			replace: true,
			scope: {},
			link: function($scope, $element, $attrs) {
				
				Highcharts.setOptions(HIGHCHARTS_OPTIONS());

				var chart = new Highcharts.Chart({
					chart: {
						renderTo: 'income-ereit-historical-dividends-chart',
						type: "areaspline",
						states: {
							hover: {
								enabled: false
							}
						}
					},
					series: [{
						color: "hsl(210,75%,65%)",
						fillColor: {
							linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
							stops: [
								[0, "rgba(99,166,233,0.5)"],
								[1, "rgba(99,166,233,0)"]
							]
						},
						data: [{ y: 0, marker: {enabled: false}}, 111.06, 360.37, 637.63, 921.19, 1180.09, 1441.87, 1706.52],
						dataLabels: {
							crop: false,
							enabled: false
						},
						marker: {
							radius: 6
						},
						name: 'Cumulative Dividends'
					}],
					tooltip: {
						enabled: true,
						formatter: function() {
							if(this.x === null) {
								return false;
							} else {
								return 'Cumulative Dividends: ' + $filter('currency')(this.y, '$', 0);
							}
						}
					},
					xAxis: {
						categories: [" ", "Q1 2016", "Q2 2016", "Q3 2016", "Q4 2016", "Q1 2017", "Q2 2017", "Q3 2017"],
						lineColor: "rgba(255,255,255,0.2)",
						style: {
							color: "rgba(255,255,255,0.5)"
						},
						tickmarkPlacement: "on",
						tickColor: "rgba(255,255,255,0.2)"
					},
					yAxis: {
						labels: {
							formatter: function() {
								return "$" + this.value;
							},
							style: {
								color: "rgba(255,255,255,0.5)"
							}
						},
						gridLineColor: "rgba(255,255,255,0.2)",
						tickInterval: 250
					}
				});
			}
		};
	}
})(window.angular);